export default "__VITE_ASSET__DYwow5N9__"